import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface TingkatItem {
  id?: number;
  value: string;
  label: string;
  jenjang: string | null;
  urutan?: number;
}

// Daftar bawaan: dipakai selama data dari server belum ada / gagal dimuat
export const TINGKAT_DEFAULT: TingkatItem[] = [
  { value: '7', label: 'Kelas 7', jenjang: 'MTs' },
  { value: '8', label: 'Kelas 8', jenjang: 'MTs' },
  { value: '9', label: 'Kelas 9', jenjang: 'MTs' },
  { value: '10', label: 'Kelas 10', jenjang: 'MA' },
  { value: '11', label: 'Kelas 11', jenjang: 'MA' },
  { value: '12', label: 'Kelas 12', jenjang: 'MA' },
];

export function useTingkat() {
  const { data, isLoading } = useQuery({
    queryKey: ['tingkat-kelas'],
    queryFn: async () => {
      const res = await api.get<TingkatItem[]>('/api/tingkat');
      return res.data || [];
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const tingkatList: TingkatItem[] = data && data.length > 0 ? data : TINGKAT_DEFAULT;
  return { tingkatList, isLoading };
}

// Membuat objek tarif { '7': nilai, '8': nilai, ..., 'Semua': 0 } dari daftar tingkat
export function buildTarifTingkat(
  list: TingkatItem[],
  nilai = 0
): Record<string, number> {
  const tarif: Record<string, number> = {};
  list.forEach((t) => {
    tarif[t.value] = nilai;
  });
  tarif['Semua'] = 0;
  return tarif;
}